import lockSvg from "@/assets/icons/lock.svg";
import mailSvg from "@/assets/icons/mail.svg";
import pulseLogo from "@/assets/icons/zing-pulse.svg";
import beforeAfterBg from "@/assets/img/paywall/before-after-bg.png";
import stars from "@/assets/img/reviewStars.svg";
import { mapFemaleEnterImgByLng, mapMaleEnterImgByLng } from "@/components/Deeplink Screen/utils";
import { bodyScanReportImagesMap } from "@/components/Upsells/BodyScan/utils";
import { workbookImgMap } from "@/components/Upsells/NutritionGuide/utils";
import {
    FemPaywallImagesByBodyFatRange,
    PaywallImagesByBodyFatRange,
} from "@/constants/bodyMetrics";
import { manBodyPicByBodyId } from "@/constants/bodyPicByBodyId";
import { femaleBodyPicByBodyId } from "@/constants/bodyType";
import { COMPONENTS } from "@/constants/components";
import { Languages } from "@/constants/languages";
import femaleLoaderBackground from "@/female/assets/backgrounds/loader-bg.webp";
import femaleStaticImproveFitnessChart from "@/female/assets/charts/improve-fitness.webp";
import femaleLoader from "@/female/assets/loaders/female-loader.webp";
import femaleUsers from "@/female/assets/loaders/female-loader-users.webp";
import femaleUser1 from "@/female/assets/reviews/female-user1.png";
import {
    mapGoalInWeeksLoseWeightChartByLng,
    mapGoalInWeeksMuscleGainChartByLng,
} from "@/female/constants/map-localised-images";
import maleLoaderBackground from "@/male/assets/backgrounds/loader-background.webp";
import maleStaticImproveFitnessChart from "@/male/assets/charts/male-improve-fitness.webp";
import maleLoader from "@/male/assets/loaders/male-loader.webp";
import testUsers from "@/male/assets/loaders/testUsers.webp";
import user1 from "@/male/assets/reviews/1.png";
import bothJourneyWaterBottle from "@/male/assets/upgrade-funnel/icons/progress-loader/water-bottle.svg";
import bothJourneyWaterOption2To6 from "@/male/assets/upgrade-funnel/icons/progress-loader/water-option-2-to-6.svg";
import bothJourneyWaterOption6Plus from "@/male/assets/upgrade-funnel/icons/progress-loader/water-option-6-plus.svg";
import bothJourneyWaterOptionUpTo2 from "@/male/assets/upgrade-funnel/icons/progress-loader/water-option-up-to-2.svg";

export const imagesToPreload = (
    isFemale: boolean,
    language: Languages
): Partial<Record<COMPONENTS, string[]>> => ({
    [COMPONENTS.FIRST_LOADER]: isFemale ? [femaleLoaderBackground] : [maleLoaderBackground],
    [COMPONENTS.LOADER]: isFemale ? [femaleUsers, femaleLoader] : [testUsers, maleLoader],
    [COMPONENTS.EMAIL]: isFemale ? [pulseLogo, mailSvg, lockSvg] : [mailSvg, lockSvg],
    [COMPONENTS.PROGRESS_LOADER]: isFemale ? [femaleUser1, stars] : [user1, stars],
    [COMPONENTS.BOTH_JOURNEY_PROGRESS_LOADER]: isFemale
        ? [femaleUser1, stars]
        : [
              user1,
              stars,
              bothJourneyWaterBottle,
              bothJourneyWaterOptionUpTo2,
              bothJourneyWaterOption2To6,
              bothJourneyWaterOption6Plus,
          ],
    [COMPONENTS.AI_PAYWALL]: isFemale
        ? [
              beforeAfterBg,
              ...Object.values(FemPaywallImagesByBodyFatRange),
              ...Object.values(femaleBodyPicByBodyId),
          ]
        : [
              beforeAfterBg,
              ...Object.values(PaywallImagesByBodyFatRange),
              ...Object.values(manBodyPicByBodyId),
          ],
    [COMPONENTS.CHART]: isFemale
        ? [
              mapGoalInWeeksLoseWeightChartByLng[language],
              mapGoalInWeeksMuscleGainChartByLng[language],
              femaleStaticImproveFitnessChart,
          ]
        : [maleStaticImproveFitnessChart],
    [COMPONENTS.BODY_SCAN]: [bodyScanReportImagesMap[language]],
    [COMPONENTS.NUTRITION_GUIDE]: [workbookImgMap[language]],
    [COMPONENTS.DEEPLINK]: [mapFemaleEnterImgByLng[language], mapMaleEnterImgByLng[language]],
});
